import { useTranslation } from 'react-i18next'
import Modal from '../../common/Modal/Modal'
import { useCallback, useMemo, useState } from 'react'

interface Props {
  onClose: () => void
  handleSelectionChange: (data: SelectionState) => void
  currentSelection?: SelectionState
  availableOptions?: SelectionState
}
export interface SelectionState {
  hasReplacement: boolean
  missingReplacement: boolean
  noData: boolean
  returnWithoutReplacement: boolean
  processingOrder: boolean
}
export default function ReplacementStateSelector({
  onClose,
  handleSelectionChange,
  currentSelection,
  availableOptions,
}: Props) {
  const { t } = useTranslation('common')

  const [hasReplacement, setHasReplacement] = useState(!!currentSelection?.hasReplacement)
  const [missingReplacement, setMissingReplacement] = useState(!!currentSelection?.missingReplacement)
  const [noData, setNoData] = useState(!!currentSelection?.noData)
  const [processingOrder, setProcessingOrder] = useState(!!currentSelection?.processingOrder)
  const [returnWithoutReplacement, setReturnWithoutReplacement] = useState(!!currentSelection?.returnWithoutReplacement)

  const selectedState = useMemo(() => {
    return { hasReplacement, missingReplacement, noData, returnWithoutReplacement, processingOrder }
  }, [hasReplacement, missingReplacement, noData, processingOrder, returnWithoutReplacement])

  const handleApplyClick = useCallback(() => {
    handleSelectionChange(selectedState)
    onClose()
  }, [handleSelectionChange, onClose, selectedState])
  return (
    <Modal title={t('REPLACEMENT_ORDER_STATE')} onClose={onClose} visible={true}>
      <div className="grid-cols-cc">
        <div className="driverModalParent replacementModal">
          {availableOptions?.hasReplacement && (
            <div>
              <div className="flex">
                <input onChange={() => setHasReplacement(!hasReplacement)} checked={hasReplacement} type="checkBox" />
                <i className="icon-change-car" style={{ color: '#39B54A', fontSize: '20px' }}></i>
              </div>
              <label>{t('HAS_REPLACEMENT_ORDER')}</label>
            </div>
          )}
          {availableOptions?.returnWithoutReplacement && (
            <div>
              <div className="flex">
                <input
                  onChange={() => setReturnWithoutReplacement(!returnWithoutReplacement)}
                  checked={returnWithoutReplacement}
                  type="checkBox"
                />
                <i className="icon-delivery" style={{ color: '#39B54A', fontSize: '20px' }}></i>
              </div>
              <label>{t('RETURN_WITHOUT_REPLACEMENT')}</label>
            </div>
          )}
          {availableOptions?.missingReplacement && (
            <div>
              <div className="flex">
                <input
                  onChange={() => setMissingReplacement(!missingReplacement)}
                  checked={missingReplacement}
                  type="checkBox"
                />
                <i className="icon-change-generic" style={{ color: 'red', fontSize: '20px' }}></i>
              </div>
              <label>{t('MISSING_REPLACEMENT_ORDER')}</label>
            </div>
          )}
          {availableOptions?.processingOrder && (
            <div>
              <div className="flex">
                <input
                  onChange={() => setProcessingOrder(!processingOrder)}
                  checked={processingOrder}
                  type="checkBox"
                />
                <i className="icon-pending" style={{ color: '#707070', fontSize: '18px' }}></i>
              </div>
              <label>{`${t('STATUS_PENDING')} / ${t('PROCESSING')}`}</label>
            </div>
          )}
          {availableOptions?.noData && (
            <div>
              <div className="flex">
                <input onChange={() => setNoData(!noData)} checked={noData} type="checkBox" />
              </div>
              <label>{t('NO_DATA')}</label>
            </div>
          )}
          <div className="driverModalInput">
            <button onClick={handleApplyClick} style={{ margin: '0px' }}>
              {t('APPLY')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
